// extracted by mini-css-extract-plugin
export default {"container":"Guideline_container__ikL0N","icon":"Guideline_icon__AMCgG","message":"Guideline_message__Lan6D"};